const Statistics = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#ABACD3" />
      <path
        d="M10 10V27C10 28.66 11.34 30 13 30H30"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 25L17.59 19.64C18.35 18.76 19.7 18.7 20.52 19.53L21.47 20.48C22.29 21.3 23.64 21.25 24.4 20.37L29 15"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { Statistics };
